/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type IntlService from "ember-intl/services/intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import MedicalEventJournalEvent from "parog-web/models/medical-event-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class MedicalEventEditionFormComponent extends CrudJournalEventBaseComponent {
  static forcDisplayName = "Événement médical";
  static fullComponentId = "medical-event/edition-form";

  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = MedicalEventJournalEvent;
  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  submitButtonTitle = "Sauvegarder";

  get occurredAt(): string {
    return this.changeset.get("occurredAt")
      ? this.intl.formatDate(this.changeset.get("occurredAt"))
      : "date inconnue";
  }

  get interventionType(): string {
    return this.changeset.get("interventionType") || "type inconnu";
  }

  get comment(): string {
    return this.changeset.get("comment") || "";
  }

  get allInterventionTypes(): string[] {
    const interventionTypes = [
      "Hospitalisation",
      "Intervention chirurgicale",
      "Consultation spécialiste",
      "Examen médical",
      "Suivi médicamenteux",
      "État de santé",
      "Une infection",
      "Un retard de règle, une grossesse",
      "Un problème avec mon traitement",
      "Un nouveau médicament",
      "Un problème de peau",
      "Autre"
    ];

    return interventionTypes;
  }

  afterCompleted = (): void => {
    if (!this.session.medic) this.router.transitionTo("/patient-web/chat");
    else {
      const tab = this.changeset.get("willSendMessage")
        ? "consult-chat"
        : "consult-timeline";
      this.router.transitionTo(
        `/medics-web/patients/${this.patient.id}/dashboard`,
        {
          queryParams: { tab }
        }
      );
    }
  };

  async save(): Promise<typeof this.journalEventClass> {
    const model = await super.save();

    if (!this.changeset.get("willSendMessage") && !this.session.patient)
      return model;

    await this.store
      .createRecord("patient-chat-message-sent-journal-event", {
        occurredAt: new Date(),
        triggeringJournalEvent: model,
        patient: model.patient,
        creator: model.creator,
        body: "Événement médical envoyé"
      })
      .save();

    return model;
  }
}
